import { Dispatch, SetStateAction } from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import dayjs from 'dayjs';

import theme from '@styles/theme';
import { autoHyphen } from '@utils/common';
import { SEE_SHARED_USER_LIST } from '@graphql/queries';
import { Query } from '@graphql/types';
import { getSharedStatus } from '@lib/enum';

import { FlexBox } from '@components/styled/StyledComponents';
import StyledModal from '@components/styled/StyledModal';
import Loader from '@components/share/Loader';

type CoOwnershipListModalProps = {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    petId: number;
};

const CoOwnershipListModal = ({
    isOpen,
    setIsOpen,
    petId
}: CoOwnershipListModalProps) => {
    const { data, loading } = useQuery<Pick<Query, 'seeSharedUserList'>>(
        SEE_SHARED_USER_LIST,
        {
            variables: {
                petId
            }
        }
    );

    const sharedUserList = data?.seeSharedUserList ?? [];
    const totalLength = sharedUserList.length ?? 0;

    return (
        <StyledModal
            title="공유자 목록"
            isOpen={isOpen}
            closeBtnHandler={() => setIsOpen(false)}
        >
            <Wrapper>
                {loading && <Loader />}
                {totalLength === 0 && (
                    <EmptyList>등록된 공유자가 없습니다.</EmptyList>
                )}
                {sharedUserList.map((data, index) => (
                    <List key={`${data?.suId}-${index}-coowner-list`}>
                        <FlexBox
                            $justifyContent="space-between"
                            $margin="0 0 8px"
                        >
                            <Text>
                                {data?.nickName
                                    ? `${data?.nickName}${
                                          data?.regStatus !== 3
                                              ? ` (${getSharedStatus(
                                                    data?.regStatus as number
                                                )})`
                                              : ''
                                      }`
                                    : '-'}
                            </Text>
                            {data?.shared && <Badge>공유자</Badge>}
                        </FlexBox>
                        <FlexBox $justifyContent="space-between">
                            <Text>
                                {data?.cellphone
                                    ? autoHyphen(data?.cellphone)
                                    : '-'}
                            </Text>
                            <Text>
                                {data?.createdAt
                                    ? dayjs(data?.createdAt).format(
                                          'YYYY-MM-DD'
                                      )
                                    : '-'}
                            </Text>
                        </FlexBox>
                    </List>
                ))}
            </Wrapper>
        </StyledModal>
    );
};

export default CoOwnershipListModal;

const Wrapper = styled.ul`
    height: 390px;
    border-top: ${theme.colors.blackColor} 1px solid;
    overflow-y: auto;
`;
const EmptyList = styled.li`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 390px;
`;
const List = styled.li`
    padding: 20px 8px;
    border-bottom: ${theme.colors.ultraLightGrayBorder} 1px solid;
`;
const Text = styled.span``;
const Badge = styled.span`
    padding: 4px 8px;
    font-size: 12px;
    line-height: 1;
    color: ${theme.colors.pointGreen};
    border: ${theme.colors.pointGreen} 1px solid;
    border-radius: 4px;
`;
